import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import Close from "@material-ui/icons/Close";
import { I18n } from "@aws-amplify/core";
import { Checkbox, CircularProgress, Dialog, Radio } from "@material-ui/core";

import { fetchGet, fetchPost, fetchPostError } from "../../api/fetch";
import { roles } from "../../constants/roles";
import Warning from './assets/warning.svg';
import images from "../../assets/img/images";
import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';

const styles = {
  orderInfoPopup: {
    minWidth: "800px",
    minHeight: "350px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  orderInfoPopupNav: {
    width: "100%",
    height: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    placeItems: "center",
    marginBottom: "32px",
    '@media(max-width: 470px)': {
      marginBottom: "0px",
      fontSize: "16px",
      boxSizing: "border-box",
      padding: "16px"
    }
  },
  interactPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  orderTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    "& div": {
      marginLeft: "8px",
    },
    '@media(max-width: 470px)': {
      fontSize: "16px",
    }
  },
  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },
  orderInfo: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    columnGap: "16px",
    alignSelf: "flex-start",
    width: "100%",
    maxWidth: "950px",
    padding: "0 10px",
    marginBottom: "24px",
  },
  orderInfoSubItems: {
    boxSizing: "border-box",
  },
  infoSubtitle: {
    fontWeight: "500",
    width: "100%",
  },
  infoValue: {
    color: "rgba(0,0,0,0.54)",
  },
  tableContainer: {
    width: "100%",
    overflow: "auto",
  },
  orderRequestTable: {
    width: "100%",
  },
  orderResend: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    width: "100%",
  },
  resendCta: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    minWidth: "600px",
  },
  selectionSection: {
    display: "flex",
    width: "400px"
  },
  selectionOption: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginRight: "16px",
  },
  radioItem: {
    width: "150px",
  },
  // REMOVE DIALOG
  removeDialog: {
    width: "336px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    boxSizing: "border-box"
  },
  removeNav: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: "16px",
  },
  imageContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "16px",
  },
  popupButtonContainer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "space-around",
  },
  popupConfirmBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    marginLeft: "24px",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  popupCancelBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "60px 38px 300px 146px 120px 108px 90px 100px 100px 100px 100px 100px 100px 400px",
    gridColumnGap: "3px",
    backgroundColor: "white",
    position: "sticky",
    "& th": {
      backgroundColor: "#e5f4f6",
      height: "69px",
      display: "flex",
      alignItems: "center",
      fontWeight: "500",
    }
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "60px 38px 300px 146px 120px 108px 90px 100px 100px 100px 100px 100px 100px 400px",
    gridColumnGap: "3px",
    "& th": {
      height: "40px",
    },
    "& td": {
      color: "rgba(0,0,0,0.54)",
      minHeight: "40px",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
    }
  },
  tableHeaderUser: {
    gridTemplateColumns: "300px 146px 120px 108px 100px 100px 100px 100px 100px 100px",
  },
  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
  },
  confirmBtn: {
    padding: "0 16px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  delete: {
    color: "#eb3c39",
    fontWeight: "500",
    width: "100%",
  },
  mobileDelete: {
    color: "#eb3c39",
    fontWeight: "500",
    width: "40px",
    margin: "0 8px",
  },
  deleteItem: {
    cursor: "pointer",
  },
  mobileDeleteItem: {
    cursor: "pointer",
    padding: "12px",
  },
  tableCheckbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cellCenterIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  deleteIcon: {
    width: "14px",
    cursor: "pointer",
  },
  mobileContainer: {
    width: "100%",
    maxWidth: "360px",
    height: "640px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #dddddd",
  },
  mobileOrderInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "8px",
    color: "rgba(0, 0, 0, 0.87)",
    marginTop: "16px",
  },
  orderRequestContainer: {
    width: "100%",
    flexGrow: "1",
    overflow: "scroll",
    position: "relative",
  },
  mobileOrdReqContHeader: {
    width: "100%",
    height: "64px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #dddddd",
    boxSizing: "border-box",
    color: "rgba(0, 0, 0, 0.87)",
    position: "sticky",
    backgroundColor: "white",
    top: "0",
    zIndex: "1",
  },
  mobileInfoRow: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  mobileOrderRequestRow: {
    width: "100%",
    minHeight: "64px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #dddddd",
    boxSizing: "border-box",
    color: "rgba(0, 0, 0, 0.54)",
  },
  mobileOrderRequestInfo: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    paddingLeft: "8px",
    flexGrow: "1",
  },
  mobileOrderRequestDesc: {
    fontWeight: "500",
    color: "rgba(0, 0, 0, 0.87)",
  },
  reqStatus: {
    color: "#68ac58"
  },
  reqStatusError: {
    color: "#eb3c39"
  },
  inline: {
    display: "inline-block"
  },
  replenishment: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  replenishmentExtra: {
    display: "flex",
    justifyContent: "space-between",
  },
  replenishmentValue: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  errorSubtitle: {
    color: "red",
    padding: "0 8px",
    paddingTop: "4px",
  },
  regularSubtitle: {
    color: "rgba(0,0,0,0.87)"
  },
  mobileOrderRequestProds: {
    paddingLeft: "8px",
    minWidth: "120px",
    flexGrow: "1",
  },
  mobileOrderRequestQty: {
    minWidth: "32px"
  },
  ctaContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "44px",
  },
  mobileConfirmBtn: {
    width: "100%",
    height: "44px",
    borderRadius: "0",
  },
  smallText: {
    fontSize: "12px",
    padding: "4px 12px",
    wordWrap: "break-word",
    '@media(max-width: 470px)': {
      padding: "4px 0px",
    }
  },
  productError: {
    backgroundColor: "#fdeceb",
  },
};

const generateDate = date => {
  const localDate = new Date(date + " UTC")

  return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).replace(/,/g, "")
}

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const OrderPopup = (props) => {
  const { classes, language } = props;

  const [sendingRequest, setSendingRequest] = useState(false);
  const [orderRequests, setOrderRequests] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkedCount, setCheckedCount] = useState(0);
  const [checkboxState, setCheckboxState] = useState(false);
  const [checkboxStateInd, setCheckboxStateInd] = useState(false);
  const [checkCancel, setCheckCancel] = useState(false)
  const [checkTransmission, setCheckTransmission] = useState(false);
  const [removeDialog, setRemoveDialog] = useState(false);
  const [resendDialog, setResendDialog] = useState(false);
  const [cancelDialog, setCancelDialog] = useState(false);
  const [cancelDialogError, setCancelDialogError] = useState(false);
  const [cancelDialogIssue, setCancelDialogIssue] = useState(false);
  const [errorItemsCount, setErrorItemsCount] = useState(0);
  const [confirmedItemsCount, setConfirmedItemsCount] = useState(0);
  const [orderStatus, setOrderStatus] = useState();
  const [showRetryReleaseDialog, setShowRetryReleaseDialog] = useState(false);
  const [retryReleaseSuccessDialog, setRetryReleaseSuccessDialog] = useState(false);
  const [retryReleaseErrorDialog, setRetryReleaseErrorDialog] = useState(false);
  // Set to true once a release retry has succeeded, so the "Retry Order Release"
  // button hides immediately (props.order is stale until the popup is reopened).
  const [orderReleased, setOrderReleased] = useState(false);

  const handleSelectCancel = () => {
    if (!checkCancel) {
      setCheckCancel(true)
      setCheckTransmission(false)
    } else {
      setCheckCancel(false)
    }

    setOrderRequests(orderRequests.map(r => { return { ...r, checked: false } }))
    setCheckedItems([])
    setCheckedCount(0)
    setCheckboxState(false)
    setCheckboxStateInd(false)
  }

  const handleSelectTransmission = () => {
    if (!checkTransmission) {
      setCheckTransmission(true)
      setCheckCancel(false)
    } else {
      setCheckTransmission(false)
    }

    setOrderRequests(orderRequests.map(r => { return { ...r, checked: false } }))
    setCheckedItems([])
    setCheckedCount(0)
    setCheckboxState(false)
    setCheckboxStateInd(false)
  }

  useEffect(() => {
    try {
      fetchGet(`order/${props.order.order_id}`)
        .then(order => {
          setOrderRequests(order.order_request.map(order => { return { ...order, checked: false } }))
          handleErrorProductsCount(order.order_request)
          setOrderStatus(language === 'en' ? order.order_status_description_en : order.order_status_description_fr)
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingRequest]);

  const handleErrorProductsCount = products => {
    let itemCount = 0;
    let confirmedItemCount = 0;

    products.forEach(p => productError(p.sys_order_req_status_id) ? itemCount++ : null)
    setErrorItemsCount(itemCount)
    products.forEach(p => productConfirmed(p.sys_order_req_status_id) || p.sum_outstanding_quantity > 0 ? confirmedItemCount++ : null)
    setConfirmedItemsCount(confirmedItemCount)
    if (itemCount > 0) setCheckTransmission(true)
  }

  const handleResend = () => {
    const body = {
      "order_request_ids": checkedItems.map(r => r.id)
    }
    setSendingRequest(true)

    try {

      fetchPost(`order/${props.order.order_id}/resend`, body)
        .then(() => {
          setResendDialog(true)
          try {
            fetchGet(`order/${props.order.order_id}`)
              .then(order => {
                console.log(order)
                setOrderRequests(order.order_request.map(order => { return { ...order, checked: false } }))
                handleErrorProductsCount(order.order_request)
                setSendingRequest(false)
                setCheckboxState(false)

                try {
                  fetchGet(`order_zone_details${props.vmiIds[0] ? `?vmi=${props.vmiIds.join(",")}` : ""}?limit=${props.searchLimit}&offset=${props.searchOffset}`)
                    .then(data => {
                      props.setOrders(data.items)
                      props.setOrdersFiltered(data.items)
                    })
                    .catch(e => console.error(e))
                } catch (e) {
                  console.log(e);
                }
              })
              .catch(e => console.error(e))
          } catch (e) {
            console.log(e);
          }
        })
      setCheckedItems([])
      setCheckedCount(0)
    } catch (e) {
      console.log(e);
    }
  }

  const handleCancelLine = () => {
    const body = {
      "order_request_ids": checkedItems.map(r => r.id)
    }
    setSendingRequest(true)

    try {
      fetchPostError(`order/${props.order.order_id}/cancel`, body)
        .then(async (res) => {
          setCheckCancel(false)
          setCancelDialog(false);

          if (Object.keys(res).length === 0 && res.status !== 400) {

            try {
              fetchGet(`order/${props.order.order_id}`)
                .then(order => {
                  setOrderRequests(order.order_request.map(order => { return { ...order, checked: false } }))
                  handleErrorProductsCount(order.order_request)
                  setSendingRequest(false)
                  setCheckboxState(false)

                  try {
                    fetchGet(`order_zone_details${props.vmiIds[0] ? `?vmi=${props.vmiIds.join(",")}` : ""}?limit=${props.searchLimit}&offset=${props.searchOffset}`)
                      .then(data => {
                        props.setOrders(data.items)
                        props.setOrdersFiltered(data.items)
                      })
                      .catch(e => console.error(e))
                  } catch (e) {
                    console.log(e);
                  }
                })
                .catch(e => console.error(e))
            } catch (e) {
              console.log(e);
            }
          } else {
            setCheckCancel(false);
            setSendingRequest(false);

            let txt = await res.text();
            let message = JSON.parse(txt)

            if (message.Message.localeCompare('Order request in processing') === 0) {
              setCancelDialog(false);
              setCancelDialogError(true);
            } else if (message.Message.localeCompare('Cancelation issues') === 0) {
              setCancelDialog(false);
              setCancelDialogIssue(true);

            } else if (message.Message.localeCompare("Status not matching") === 0) {
              setCancelDialog(false);
              setCancelDialogIssue(true);
            }
          }
        })
      setCheckedItems([])
      setCheckedCount(0)
    } catch (e) {
      console.log(e);
    }
  }

  const handleRemove = id => {
    const orderRequestIds = id ? [id] : checkedItems.map(r => r.id)

    const body = {
      "order_request_ids": orderRequestIds
    }

    setSendingRequest(true)

    try {
      setRemoveDialog(false)
      fetchPost(`v1/order/${props.order.order_id}/remove`, body)
        .then(res => {
          setSendingRequest(false);

          try {
            fetchGet(`order/${props.order.order_id}`)
              .then(order => {
                if (order.order_request.length > 0) {
                  setOrderRequests(order.order_request.map(order => { return { ...order, checked: false } }))
                  handleErrorProductsCount(order.order_request)
                  setCheckboxState(false)
                } else {
                  props.handleClose(false)
                }
                try {
                  fetchGet(`order_zone_details${props.vmiIds[0] ? `?vmi=${props.vmiIds.join(",")}` : ""}?limit=${props.searchLimit}&offset=${props.searchOffset}`)
                    .then(data => {
                      props.setOrders(data.items)
                      props.setOrdersFiltered(data.items)
                    })
                    .catch(e => console.error(e))
                } catch (e) {
                  console.log(e);
                }
              })
              .catch(e => console.error(e))
          } catch (e) {
            console.log(e);
          }
        })

      setCheckedItems([])
      setCheckedCount(0)
      setCheckboxState(false)
    } catch (e) {
      console.log(e);
    }
  }

  const retryOrderRelease = async () => {
    setSendingRequest(true)
    setShowRetryReleaseDialog(false)
    try {
      const orderId = props.order?.order_id;
      const sordNo = props.order?.order_customer_order_id;

      if (!orderId || !sordNo) {
        setSendingRequest(false)
        setRetryReleaseErrorDialog(true)
        return
      }

      const body = {
        release: [
          {
            luke_order_id: orderId,
            sord_no: sordNo,
          },
        ],
      };

      await fetchPost(`v1/order/release`, body)

      setRetryReleaseSuccessDialog(true)
      setOrderReleased(true)

      try {
        fetchGet(`order/${props.order.order_id}`)
          .then(order => {
            setOrderRequests(order.order_request.map(order => { return { ...order, checked: false } }))
            handleErrorProductsCount(order.order_request)
            setOrderStatus(language === 'en' ? order.order_status_description_en : order.order_status_description_fr)
            setSendingRequest(false)
            setCheckboxState(false)
            setCheckboxStateInd(false)
            setCheckedItems([])
            setCheckedCount(0)

            try {
              fetchGet(`order_zone_details${props.vmiIds[0] ? `?vmi=${props.vmiIds.join(",")}` : ""}?limit=${props.searchLimit}&offset=${props.searchOffset}`)
                .then(data => {
                  props.setOrders(data.items)
                  props.setOrdersFiltered(data.items)
                })
                .catch(error => console.error(error))
            } catch (error) {
              console.log(error);
            }
          })
          .catch(error => console.error(error))
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error)

      setSendingRequest(false)
      setRetryReleaseErrorDialog(true)
    }
  }

  const handleCheckItem = (e, product) => {
    if (e.target.checked) {
      setCheckedCount(checkedCount + 1)

      if (checkedCount + 1 === orderRequests.length) {
        setCheckboxStateInd(false)
        setCheckboxState(true)
      } else {
        setCheckboxStateInd(true)
        setCheckboxState(false)
      }
      setCheckedItems(checkedItems => [...checkedItems, product])
      setOrderRequests(orderRequests.map(r => {
        if (product.id === r.id) {
          return {
            ...r,
            checked: true
          }
        } else {
          return r
        }
      }))
    } else {
      setCheckedCount(checkedCount - 1)
      setCheckedItems(checkedItems.filter(p => p.id !== product.id))
      if (checkedCount - 1 === 0) {
        setCheckboxStateInd(false)
        setCheckboxState(false)
      } else {
        setCheckboxStateInd(true)
        setCheckboxState(false)
      }
      setOrderRequests(orderRequests.map(r => {
        if (product.id === r.id) {
          return {
            ...r,
            checked: false
          }
        } else {
          return r
        }
      }))
    }
  }

  const checkAll = () => {
    if (checkCancel) {
      if (checkedCount === 0) {
        setOrderRequests(orderRequests.map(r => { return { ...r, checked: productConfirmed(r.sys_order_req_status_id) ? true : false, toggle: false } }))
        setCheckedItems(orderRequests.filter(r => productConfirmed(r.sys_order_req_status_id)))
        setCheckedCount(orderRequests.filter(r => productConfirmed(r.sys_order_req_status_id)).length)
        setCheckboxState(true)
        setCheckboxStateInd(false)
      } else {
        setOrderRequests(orderRequests.map(r => { return { ...r, checked: false } }))
        setCheckedItems([])
        setCheckedCount(0)
        setCheckboxState(false)
        setCheckboxStateInd(false)
      }
    } else {
      if (checkedCount === 0) {
        setOrderRequests(orderRequests.map(r => { return { ...r, checked: productError(r.sys_order_req_status_id) ? true : false, toggle: false } }))
        setCheckedItems(orderRequests.filter(r => productError(r.sys_order_req_status_id)))
        setCheckedCount(orderRequests.filter(r => productError(r.sys_order_req_status_id)).length)
        setCheckboxState(true)
        setCheckboxStateInd(false)
      } else {
        setOrderRequests(orderRequests.map(r => { return { ...r, checked: false } }))
        setCheckedItems([])
        setCheckedCount(0)
        setCheckboxState(false)
        setCheckboxStateInd(false)
      }
    }
  }

  const productError = statusId => {
    if (['160c4567-3b66-43af-b88d-9d74d9e2dbb6', '0b54207c-5295-42cf-a79e-6d99912e8336'].includes(statusId)) {
      return true
    } else {
      return false
    }
  }

  const productConfirmed = statusId => {
    if (["9cfaa303-1844-4052-a760-fc429422b45a", '96c7e325-5a1e-41fb-8d34-4e103c12c7cd'].includes(statusId)) {
      return true
    } else {
      return false
    }
  }

  const level = get(props, ["userRole", "level"]);

  return (
    getWidth() > 478 ?
      <div className={classes.orderInfoPopup}>
        <Dialog open={removeDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setRemoveDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setRemoveDialog(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={Warning} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("remove_dialog_p1")} (${checkedItems.length}) ${I18n.get("remove_dialog_p2")}`}</div>
            <div>{I18n.get("remove_dialog_p3")}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setRemoveDialog(false)}
              >{I18n.get("site_cancel").toUpperCase()}</button>
              <button
                className={classes.popupConfirmBtn}
                type="button"
                onClick={() => handleRemove()}
              >{I18n.get("site_confirm").toUpperCase()}</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={cancelDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setCancelDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setCancelDialog(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={Warning} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("order_cancel")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setCancelDialog(false)}
              >{I18n.get("site_cancel").toUpperCase()}</button>
              <button
                className={`${classes.popupConfirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""}`}
                type="button"
                onClick={() => handleCancelLine()}
              >{I18n.get("site_confirm").toUpperCase()}</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={showRetryReleaseDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setShowRetryReleaseDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setShowRetryReleaseDialog(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={Warning} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("retry_order_release_confirm")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setShowRetryReleaseDialog(false)}
              >{I18n.get("site_cancel").toUpperCase()}</button>
              <button
                className={`${classes.popupConfirmBtn} ${sendingRequest ? classes.disabledButton : ""}`}
                type="button"
                onClick={() => retryOrderRelease()}
              >{I18n.get("site_confirm").toUpperCase()}</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={retryReleaseSuccessDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setRetryReleaseSuccessDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setRetryReleaseSuccessDialog(false)} />
              </div>
            </div>
            <div>{`${I18n.get("retry_order_release_success")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setRetryReleaseSuccessDialog(false)}
              >OK</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={retryReleaseErrorDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setRetryReleaseErrorDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setRetryReleaseErrorDialog(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={images.deleteWarningTriangle} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("retry_order_release_error")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setRetryReleaseErrorDialog(false)}
              >OK</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={cancelDialogError} PaperProps={{ style: { margin: "0" }, }} onClose={() => setCancelDialogError(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setCancelDialogError(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={images.deleteWarningTriangle} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("order_cancel_error")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setCancelDialogError(false)}
              >OK</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={cancelDialogIssue} PaperProps={{ style: { margin: "0" }, }} onClose={() => setCancelDialogIssue(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setCancelDialogIssue(false)} />
              </div>
            </div>
            <div className={classes.imageContainer}>
              <img src={images.deleteWarningTriangle} alt="Warning Sign" />
            </div>
            <div>{`${I18n.get("order_cancel_issue")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setCancelDialogIssue(false)}
              >OK</button>
            </div>
          </div>
        </Dialog>
        <Dialog open={resendDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setResendDialog(false)}>
          <div className={classes.removeDialog}>
            <div className={classes.removeNav}>
              <div className={classes.closeButton}>
                <Close onClick={() => setResendDialog(false)} />
              </div>
            </div>
            <div>{`${I18n.get("resend_dialog")}`}</div>
            <div className={classes.popupButtonContainer}>
              <button
                className={classes.popupCancelBtn}
                type="button"
                onClick={() => setResendDialog(false)}
              >OK</button>
            </div>
          </div>
        </Dialog>
        <div className={classes.orderInfoPopupNav}>
          <div className={classes.orderTitle}>
            <div>{`${I18n.get("order_noun_jrv").toUpperCase()} ${props.order.order_id}`}</div>
          </div>
          <div className={classes.closeButton}>
            <Close onClick={() => props.handleClose(false)} />
          </div>
        </div>
        <div className={classes.orderInfo}>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("companies_company")}
            </div>
            <div className={classes.infoValue}>
              {props.order.company_name}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("companies_site")}
            </div>
            <div className={classes.infoValue}>
              {props.order.site_name}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("sector")}
            </div>
            <div className={classes.infoValue}>
              {props.order.sector_name}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              VMI
            </div>
            <div className={classes.infoValue}>
              {props.order.VMI}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("status")}
            </div>
            <div className={classes.infoValue}>
              {orderStatus}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("pending_order")}
            </div>
            <div className={classes.infoValue}>
              {props.order.order_customer_order_id}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("events_createdOn")}
            </div>
            <div className={classes.infoValue}>
              {generateDate(props.order.created_on)}
            </div>
          </div>
          <div className={classes.orderInfoSubItems}>
            <div className={classes.infoSubtitle}>
              {I18n.get("events_createdBy")}
            </div>
            <div className={classes.infoValue}>
              {props.order.created_by}
            </div>
          </div>
        </div>
        {level <= roles.customerAdmin ?
          <div className={classes.orderResend}>
            <div className={classes.selectionSection}>
              {confirmedItemsCount > 0 ?
                <div className={classes.selectionOption} onClick={() => handleSelectCancel()}>
                  <Radio color="primary" checked={checkCancel} />
                  <div style={{ width: "125px" }}>{I18n.get("order_oreq_cancel")}</div>
                </div>
                : null}
              {errorItemsCount > 0 ?
                <div className={classes.selectionOption} onClick={() => handleSelectTransmission()}>
                  <Radio color="primary" checked={checkTransmission} />
                  <div style={{ width: "155px" }}>{I18n.get("order_transmission")}</div>
                </div>
                : null}
            </div>
            <div className={classes.delete}>
              {
                checkedItems.length > 0 && checkTransmission ?
                  <span className={classes.deleteItem} onClick={() => checkedCount > 0 ? setRemoveDialog(true) : null}>
                    {I18n.get("order_remove").toUpperCase()}
                  </span>
                  : null
              }
            </div>
            <div className={classes.resendCta} >
              {/* Show the "Retry Order Release" button only when the order is stuck in a
                  "Processing" status (this covers the BCxx error statuses such as BC54
                  "Error Initiating Order Release", all labelled "Processing"/"En traitement")
                  AND there is no line left in error. In that state the order lines are all
                  Confirmed/Cancelled but the order header never came back down on its own,
                  so we let the user re-trigger the release. */}
              {(props.order.order_status_en === "Processing") && errorItemsCount === 0 && !orderReleased && (
                <button className={classes.confirmBtn} style={{ marginRight: '10px' }} onClick={() => setShowRetryReleaseDialog(true)}>
                  {I18n.get("retry_order_release").toUpperCase()}
                </button>
              )}
              {
                checkCancel || errorItemsCount === 0 ?
                  <button
                    className={`${classes.confirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                    onClick={() => setCancelDialog(true)}>
                    {!sendingRequest ? `${I18n.get("null_selection1").toUpperCase()} ${checkedItems.length ? `${checkedItems.length} ` : ""}${I18n.get("null_selection2").toUpperCase()}` : <CircularProgress size={16} style={{ 'color': 'white' }} />}
                  </button>
                  :
                  <button
                    className={`${classes.confirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                    onClick={() => handleResend()}>
                    {!sendingRequest ? `${I18n.get("order_resend1").toUpperCase()} ${checkedItems.length ? `${checkedItems.length} ` : ""}${I18n.get("order_resend2").toUpperCase()}` : <CircularProgress size={16} style={{ 'color': 'white' }} />}
                  </button>
              }
            </div>
          </div>
          : null
        }
        <div className={classes.tableContainer}>
          <table className={classes.orderRequestTable}>
            <thead>
              <tr className={`${classes.tableHeader} ${level <= roles.customerAdmin ? "" : classes.tableHeaderUser}`}>
                {level <= roles.customerAdmin ?
                  <th className={classes.tableCheckbox}>
                  </th>
                  : null}
                {level <= roles.customerAdmin ?
                  <th className={classes.deleteColumn}>
                  </th>
                  : null}
                <th className={classes.tableProduct}>
                  <div className={classes.tableSubtitle}>{`${I18n.get("site_description")} (${orderRequests.length})`}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("status")}</div>
                </th>
                <th className={classes.tablePzi}>
                  <div className={classes.tableSubtitle}>{I18n.get("code_bin")}</div>
                </th>
                <th className={classes.tableCode}>
                  <div className={classes.tableSubtitle}>{I18n.get("manufacturer_item_code")}</div>
                </th>
                {level <= roles.customerAdmin ?
                  <th className={classes.tableJrv}>
                    <div className={classes.tableSubtitle}>{I18n.get("jrv_code")}</div>
                  </th>
                  : null}
                <th className={classes.tableQuantity}>
                  <div className={classes.tableSubtitle}>{I18n.get("ordered_quantity")}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("replenishment_outstanding")}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("replenishment_en_route")}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("replenishment_delivered")}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("replenishment_completed")}</div>
                </th>
                <th className={classes.tableStatus}>
                  <div className={classes.tableSubtitle}>{I18n.get("replenishment_cancelled")}</div>
                </th>
                {
                  level <= roles.customerAdmin ?
                    <th className={classes.tableMessage}>
                      <div className={classes.tableSubtitle}>{I18n.get("message")}</div>
                    </th>
                    : null
                }
              </tr>
            </thead>
            <tbody onClick={() => { console.log(orderRequests) }}>
              {orderRequests.map((p, i) =>
                <tr key={`product-${i}`} className={`${classes.tableRow} ${level <= roles.customerAdmin ? "" : classes.tableHeaderUser} ${productError(p.sys_order_req_status_id) && level <= roles.customerAdmin ? classes.productError : ""}`}>
                  {level <= roles.customerAdmin ?
                    <td className={classes.cellCenterIcon}>
                      {(productError(p.sys_order_req_status_id) && checkTransmission) || (checkCancel && productConfirmed(p.sys_order_req_status_id)) || (checkCancel && p.sum_outstanding_quantity > 0) ?
                        <Checkbox
                          color="primary"
                          checked={p.checked}
                          onChange={e => handleCheckItem(e, p)}
                        />
                        : null
                      }
                    </td>
                    : null}
                  {level <= roles.customerAdmin ?
                    <td className={classes.cellCenterIcon}>
                      {(productError(p.sys_order_req_status_id) && checkTransmission) ?
                        <img
                          onClick={() => handleRemove(p.id)}
                          src={images.deleteIcon}
                          alt="trash"
                          className={classes.deleteIcon}
                        /> : null}
                    </td>
                    : null}
                  <td>
                    <div className={`${classes.tableSubtitle}`} title={language === 'en' ? p.description_en : p.description_fr}>
                      {language === 'en' ? p.description_en : p.description_fr}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {language === 'en' ? p.sys_order_req_status_name_en : p.sys_order_req_status_name_fr}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.pzi_id}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.manufacturer_item_code}
                    </div>
                  </td>
                  {level <= roles.customerAdmin ?
                    <td>
                      <div className={classes.tableSubtitle}>
                        {p.jrv_code}
                      </div>
                    </td>
                    : null}
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.quantity}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.sum_outstanding_quantity ? p.sum_outstanding_quantity : 0}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.sum_transit_quantitty ? p.sum_transit_quantitty : 0}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.sum_to_be_placed_quantity ? p.sum_to_be_placed_quantity : 0}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.sum_placed_quantity ? p.sum_placed_quantity : 0}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.sum_canceled_quantity ? p.sum_canceled_quantity : 0}
                    </div>
                  </td>
                  {level <= roles.customerAdmin ?
                    <td>
                      <div className={`${classes.tableSubtitle} ${classes.smallText}`}>
                        {p.system_message}
                      </div>
                    </td>
                    : null}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      :
      <>
        <div className={classes.mobileContainer}>
          <div className={classes.orderInfoPopupNav}>
            <div className={classes.orderTitle}>
              <div>{`#${props.order.order_id}`}</div>
            </div>
            <div className={classes.closeButton}>
              <Close onClick={() => props.handleClose(false)} />
            </div>
          </div>
          <div className={classes.mobileOrderInfo}>
            <div>VMI : <span className={classes.mobileInfoRow}>{props.order.VMI}</span></div>
            <div>{I18n.get("status")} : <span className={classes.mobileInfoRow}>{language === 'en' ? props.order.order_status_en : props.order.order_status_fr}</span></div>
            <div>{I18n.get("pending_order")} : <span className={classes.mobileInfoRow}>{props.order.order_customer_order_id}</span></div>
            <div>{I18n.get("events_createdOn")} : <span className={classes.mobileInfoRow}>{generateDate(props.order.created_on)}</span></div>
            <div>{I18n.get("events_createdBy")} : <span className={classes.mobileInfoRow}>{props.order.created_by}</span></div>
            {errorItemsCount > 0 ? <div className={classes.errorSubtitle}>{`${errorItemsCount} ${I18n.get("product_errors")}`}</div> : null}
          </div>
          <div className={classes.orderRequestContainer}>
            <div className={classes.mobileOrdReqContHeader}>
              {level <= roles.customerAdmin && errorItemsCount > 0 ?
                <div className={classes.tableCheckbox}>
                  <Checkbox
                    color="primary"
                    onChange={e => checkAll(e)}
                    checked={checkboxState}
                    indeterminate={checkboxStateInd}
                    disabled={errorItemsCount === 0 ? true : false}
                  />
                </div>
                : null}
              <div className={classes.mobileOrderRequestProds}>{`${orderRequests.length} ${orderRequests.length === 1 ? I18n.get("site_product") : I18n.get("sidebar_products")}${checkedItems.length > 0 ? ` / ${checkedItems.length} ${I18n.get("common_selected")}` : ""}`}</div>
              <div className={classes.mobileDelete}>
                <Dialog open={removeDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setRemoveDialog(false)}>
                  <div className={classes.removeDialog}>
                    <div className={classes.removeNav}>
                      <div className={classes.closeButton}>
                        <Close onClick={() => setRemoveDialog(false)} />
                      </div>
                    </div>
                    <div className={classes.imageContainer}>
                      <img src={Warning} alt="Warning Sign" />
                    </div>
                    <div>{`${I18n.get("remove_dialog_p1")} (${checkedItems.length}) ${I18n.get("remove_dialog_p2")}`}</div>
                    <div>{I18n.get("remove_dialog_p3")}</div>
                    <div className={classes.popupButtonContainer}>
                      <button
                        className={classes.popupCancelBtn}
                        type="button"
                        onClick={() => setRemoveDialog(false)}
                      >{I18n.get("site_cancel").toUpperCase()}</button>
                      <button
                        className={classes.popupConfirmBtn}
                        type="button"
                        onClick={() => handleRemove()}
                      >{I18n.get("site_confirm").toUpperCase()}</button>
                    </div>
                  </div>
                </Dialog>
                <Dialog open={resendDialog} PaperProps={{ style: { margin: "0" }, }} onClose={() => setResendDialog(false)}>
                  <div className={classes.removeDialog}>
                    <div className={classes.removeNav}>
                      <div className={classes.closeButton}>
                        <Close onClick={() => setResendDialog(false)} />
                      </div>
                    </div>
                    <div>{`${I18n.get("resend_dialog")}`}</div>
                    <div className={classes.popupButtonContainer}>
                      <button
                        className={classes.popupCancelBtn}
                        type="button"
                        onClick={() => setResendDialog(false)}
                      >OK</button>
                    </div>
                  </div>
                </Dialog>
                {level <= roles.customerAdmin && checkedItems.length > 0 ?
                  <span className={classes.mobileDeleteItem} onClick={() => checkedCount > 0 ? setRemoveDialog(true) : null}>
                    <img
                      onClick={() => handleRemove()}
                      src={images.deleteIcon}
                      alt="trash"
                      className={classes.deleteIcon}
                    />
                  </span>
                  : null}
              </div>
              <div className={classes.mobileOrderRequestQty}>{I18n.get("qty_abv")}</div>
            </div>
            {orderRequests.map((p, i) =>
              <div className={`${classes.mobileOrderRequestRow} ${productError(p.sys_order_req_status_id) && level <= roles.customerAdmin ? classes.productError : ""}`} key={`orderRequest-${i}`}>
                {level <= roles.customerAdmin ?
                  <div className={classes.cellCenterIcon}>
                    {productError(p.sys_order_req_status_id) ?
                      <Checkbox
                        color="primary"
                        checked={p.checked}
                        onChange={e => handleCheckItem(e, p)}
                      />
                      : null
                    }
                  </div>
                  : null}
                <div className={classes.mobileOrderRequestInfo}>
                  <div className={classes.mobileOrderRequestDesc} onClick={() => p.toggle = !p.toggle}><img src={p.toggle ? DropdownDown : DropdownRight} alt="Dropdown" /> {language === 'en' ? p.description_en : p.description_fr}</div>
                  <div><span className={classes.regularSubtitle}>{I18n.get("manufacturer_item_code")}: </span> {p.manufacturer_item_code ? p.manufacturer_item_code : "-"}</div>
                  {level <= roles.customerAdmin ? <div><span className={classes.regularSubtitle}>{I18n.get("jrv_code")}: </span>{p.jrv_code}</div> : null}
                  <div><span className={classes.regularSubtitle}>{I18n.get("code_bin")}: </span>{p.pzi_id}</div>
                  <div className={`${p.sys_order_req_status_name_en !== "Error" ? classes.reqStatus : classes.reqStatusError}`}>{language === 'en' ? p.sys_order_req_status_name_en : p.sys_order_req_status_name_fr}</div>
                  {level <= roles.customerAdmin && p.system_message ? <div className={classes.smallText}>{p.system_message}</div> : null}
                  {p.toggle ?
                    <div className={classes.replenishment}>
                      <div className={classes.replenishmentExtra}>
                        <div>{I18n.get("replenishment_outstanding")}: <span className={classes.replenishmentValue}>{p.sum_outstanding_quantity ? p.sum_outstanding_quantity : 0}</span></div>
                        <div>{I18n.get("replenishment_en_route")}: <span className={classes.replenishmentValue}>{p.sum_transit_quantitty ? p.sum_transit_quantitty : 0}</span></div>
                        <div>{I18n.get("replenishment_delivered")}: <span className={classes.replenishmentValue}>{p.sum_to_be_placed_quantity ? p.sum_to_be_placed_quantity : 0}</span></div>
                        <div>{I18n.get("replenishment_completed")}: <span className={classes.replenishmentValue}>{p.sum_placed_quantity ? p.sum_placed_quantity : 0}</span></div>
                      </div>
                    </div> : null}
                </div>
                <div className={classes.mobileOrderRequestQty}>
                  {p.quantity}
                </div>
              </div>
            )}
          </div>
          {
            level <= roles.customerAdmin && errorItemsCount > 0 ?
              <div className={classes.ctaContainer}>
                <button
                  className={`${classes.confirmBtn} ${classes.mobileConfirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                  onClick={() => handleResend()}>
                  {I18n.get("order_resend").toUpperCase()}
                </button>
              </div>
              : null
          }
        </div>
      </>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(OrderPopup))
);